/**
 * In-memory cache for SKU-reason return evidence pages.
 * Dropped whenever dashboard filters change — never persisted.
 */

export const skuReasonReturnsCacheKey = ({
  clientId,
  startDate,
  endDate,
  channels = [],
  sku,
  reason,
  skip = 0,
  limit = 25,
  sortField = "requested_at",
  sortDir = "desc",
} = {}) =>
  JSON.stringify({
    clientId: clientId || "",
    startDate: startDate || "",
    endDate: endDate || "",
    channels: [...(channels || [])].filter(Boolean).sort(),
    sku: sku || "",
    reason: reason || "",
    skip,
    limit,
    sortField,
    sortDir,
  });

export class SkuReasonReturnsMemoryCache {
  constructor() {
    this.map = new Map();
  }

  get(key) {
    return this.map.get(key);
  }

  set(key, value) {
    this.map.set(key, value);
  }

  delete(key) {
    this.map.delete(key);
  }

  clear() {
    this.map.clear();
  }
}
